
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/uspin",
      function () {
        return require("private-next-pages/uGame/uspin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/uspin"])
      });
    }
  